module.exports = __webpack_public_path__ + "img/wz1.4e4e6e28.png";